module.exports = __webpack_public_path__ + "700f344ec1c2d497a4fb9d5109b44398.pdf";